import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { TourProvider } from '@reactour/tour';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import 'nprogress/nprogress.css';

import { TooltipProvider } from 'src/componentes/tooltip';
import { AuthProvider } from 'src/contexts/AuthContext';
import store from 'src/store';
import ButtonRestartStepsTour from './components/ButtonRestartStepsTour/ButtonRestartStepsTour';
import App from './App';

const queryClient = new QueryClient();

const generateMsalConfig = () => {
  const msalConfig = {
    auth: {
      clientId: '7f6b1e3a-3936-4920-8eca-5e8993d2e6a7',
      authority: 'https://login.microsoftonline.com/common/',
      redirectUri: '/',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
  };

  return msalConfig;
};

const pca = new PublicClientApplication(generateMsalConfig());
pca.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    event.eventType === EventType.SSO_SILENT_SUCCESS ||
    event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
  ) {
    const currentAccount = pca.getActiveAccount();
    if (!currentAccount) {
      pca.setActiveAccount(event.payload.account);
    }
  }
});

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <TourProvider
        position={'bottom'}
        disableDotsNavigation={true}
        disableKeyboardNavigation={['left']}
        prevButton={({ setCurrentStep }) => (
          <ButtonRestartStepsTour setCurrentStep={setCurrentStep} />
        )}
      >
        <AuthProvider>
          <MsalProvider instance={pca}>
            <TooltipProvider>
              <App />
            </TooltipProvider>
          </MsalProvider>
        </AuthProvider>
      </TourProvider>
    </QueryClientProvider>
  </Provider>
);
